import { Container, styled, Typography } from '@mui/material'

export const StyledContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0;
`

export const StyledTitle = styled(Typography)`
  padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(12)};
`

export const StyledContent = styled(Container)`
  background-color: ${props => props.theme.palette.background.paper};
  border-radius: ${props => props.theme.typography.pxToRem(8)};
  padding: ${props => props.theme.typography.pxToRem(16)};
`